import RedemptionDetailsDialog from './redemptionDetailsDialog.container';

export default RedemptionDetailsDialog